import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  button: {
    boxShadow: '2px 5px 6px -2px rgba(115, 114, 118, 0.5)',
    borderRadius: theme.spacing(0.5),
    paddingLeft: theme.spacing(3),
    justifyContent: 'left',
    textAlign: 'left',
    marginBottom: theme.spacing(2),
    width: '90%',
    minHeight: theme.spacing(6),
  },

  header: {
    color: theme.palette.brand.darkGreen,
  },
  subHeader: {
    color: theme.palette.brand.greenNature,
  },
}));

export default function ButtonCard({ header, subHeader = null, onClick }) {
  const classes = useStyles();

  return (
    <Button onClick={onClick} className={classes.button}>
      <div>
        <Typography variant="subtitle2" className={classes.header}>
          <b>{header}</b>
        </Typography>
        {subHeader && (
          <Typography variant="subtitle1" className={classes.subHeader}>
            {subHeader}
          </Typography>
        )}
      </div>
    </Button>
  );
}
